import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'home_feed-layout_element_custom_item-click';

/**
 * This is the Home Feed Layout Element Custom Item Click event. This is useful to track clicks from custom elements such as See All tile or other element

There are 3 parameter tokens:
1. Container name (On click event name)
2. Request id
3. Custom element
 */
export function trackHomeFeedLayoutElementCustomItemClick(
  customParameterToken: string,
  customParameterToken2: string,
  customParameterToken3: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: {
      customParameterToken,
      customParameterToken2,
      customParameterToken3,
    },
  });
}
